import { Facet } from "@linkfluence/models/facet";
import { PublicProductCtx } from "@radarly/models/public-pages";
import { ProductRepo } from "./ProductRepo";

export class PublicProductRepo implements ProductRepo {
  facetContext: PublicProductCtx;
  constructor(productCtx: PublicProductCtx) {
    this.facetContext = productCtx;
  }

  public getProducts(project: number, facet: Facet) {
    return Promise.resolve(this.facetContext[facet] || []);
  }
}
